import React, { ReactNode } from 'react'
import { IntlProvider } from 'react-intl';
import { languageMessage} from '../types/language';
import { ApplicationState } from "../redux/state";
import { connect } from 'react-redux';

interface Props {
    children: ReactNode,
    messages: languageMessage,
    currentLanguage: languageMessage
}

type StateProps = Pick<Props, 'currentLanguage'>;

function mapStateToProps(state: ApplicationState): StateProps {
    return {
      currentLanguage: state.language.currentLanguage
    };
}


function IntlProviderWrapper(props: Props) {
    
    return (
        <IntlProvider locale={props.currentLanguage.langcode} messages={props.currentLanguage.locale}>
            <div>
                { props.children }
            </div>
        </IntlProvider>
    )
}


const connectedIntlProviderWrapper= connect(mapStateToProps)(IntlProviderWrapper);
export default connectedIntlProviderWrapper;